import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Issue } from "src/app/domain/models/Issue";

@Injectable({providedIn: 'root'})
export abstract class IssueGateway {
  abstract create(issue: Issue): Observable<Issue>
}
